import { ApplicationRef, Component, ComponentFactoryResolver, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PopupComponent } from 'src/app/components/network-visibility/popup/popup.component';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng } from 'leaflet';
import { get } from 'http';
import { forkJoin } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
// import 'leaflet-polylinedecorator';

@Component({
  selector: 'app-telco-map',
  templateUrl: './telco-map.component.html',
  styleUrls: ['./telco-map.component.css']
})
export class TelcoMapComponent implements OnInit {


  private map!: L.Map;

  cid: any
  showFilter: any = false
  isFullscreen = false;
  bi_fullscreen: any = "fullscreen-map"
  locationList: any = []
  isLoading: any = false

  defaultZoom: any = 14
  defaultCenter: any = [17.4065, 78.4772]
  telcoCustomerList: any = [];
  isCustomer: any = false;
  locationObjectInfoList: any = []
  telcoCustomerData: any = []
  singleObjectInfoData: any = []
  jsonString: any = ""

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,private router: Router,
    private injector: Injector) {

      // this.generic_service.menuToggle.subscribe((value) => {
      //   this.menuToggle = Boolean(value)
      //   if(this.menuToggle){
      //     this.bi_fullscreen = "fullscreen-map1"
      //   }else{
      //     this.bi_fullscreen = "fullscreen-map"
      //   }

      // });
    }






  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllLocation()
    if (this.map) {
      this.map.remove();
    }
  }


  private initMap(): void {
      
    if (this.map) {
      this.map.remove();
    }
    // Initialize the map
    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });
  
    // Add tile layer
    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });
    tiles.addTo(this.map);
  }

  loadMarker(latLng: any,list: any): void {

    const iconUrl = 'assets/home-icon-illustration-design-vector.jpg';
    
    const customHtmlIcon = L.divIcon({
      className: '',
      html: `
        <div style="
          position: relative;
          width: 60px;
          height: 60px;
          background: white;
          border: 3px solid #a0d16cff;
          border-radius: 50%;
          overflow: hidden;
          box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        ">
          <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />

          <div style="
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            // border-top: 15px solid #2c3e50;
          "></div>
        </div>
      `,
      iconAnchor: [30, 30],
      popupAnchor: [0, 0]
    });

    L.marker([latLng.lat, latLng.lng], { icon: customHtmlIcon })
    .addTo(this.map).on('click', () => {
      this.telcoCustomerData = []
      this.telcoCustomerData.push(list)
      document.getElementById("view-detail")?.click()

    });
  }


//   const bounds = L.latLngBounds(points.map(p => [p.lat, p.lng]));
// this.map.fitBounds(bounds);


  removeMarker() {
    if (this.map) {
      this.map.eachLayer((layer: any) => {
        if (!layer._url) {
          this.map.removeLayer(layer);
        }
      });
    }
  }

  refreshMarker() {
    if (this.map) {
      this.map.eachLayer((layer: any) => {
        if (!layer._url) {
          this.map.removeLayer(layer);
        }
      });
    }

    for(let list of this.locationList){
      list.isChecked = false
    }

    this.isCustomer = false
  }

  toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;
  }

  getAllLocation(){
    this.generic_service.getAllLocation().subscribe(
      (res:any)=> {
        console.log(res)

        if(res.response != null && res.response.length != 0){
          for(let list of res.response){
            list.isChecked = false
          }
        }
   
        this.locationList = res.response
        console.log(this.locationList)
        this.initMap()

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }



  locationCheckList: any = [];
  
  locationCheck1(list: any, checked: any) {
    this.removeMarker()
    this.telcoCustomerList = []
    this.locationObjectInfoList = []
    const isChecked: any = checked
  
    // this.locationCheckList = []
    if (!isChecked) {
      list.isChecked = true;
      this.locationCheckList.push(list);
    } else {
      const index = this.locationCheckList.findIndex(
        (loc: any) => loc.locationId === list.locationId
      );

  
      if (index !== -1) {
        this.locationCheckList.splice(index, 1);
        console.log(index)
      }
      list.isChecked = false;
    }
    console.log(this.locationCheckList)


    if (this.locationCheckList.length === 0) {
      return;
    }
  
    const requests = this.locationCheckList.map((loc: any) =>
      this.generic_service.getTelcoCustomerByLocation(loc.zone)
    );

    const latLngPoints: { lat: number, lng: number }[] = [];

  
    forkJoin(requests).subscribe(
      (responses: any) => {
        for (const res of responses) {
          if (res.response != null) {
            this.telcoCustomerList.push(...res.response);
          }
          for(let list of this.telcoCustomerList){
            let latLng = list.customerLatLng
            if(latLng.lat && latLng.lat != null && latLng.lat != '' && latLng.lat != '0' && latLng.lat != 0){
              this.loadMarker(latLng,list)
              const customerLatLng: any = {
                lat: latLng.lat,
                lng: latLng.lng
              }

            latLngPoints.push({ lat: customerLatLng.lat, lng: customerLatLng.lng });

            }
          }
        }  
      },
      (err: any) => {
        console.log(err);
      }
    );


    const requestsLoc = this.locationCheckList.map((loc: any) =>
      this.generic_service.getAllByLocationAndCid(loc.zone)
    );

    forkJoin(requestsLoc).subscribe(
      (responses: any) => {
        for (const res of responses) {
          if (res.response != null) {
            this.locationObjectInfoList.push(...res.response);
          }
          for(let list of this.locationObjectInfoList){
            if(list.lat && list.lat != null && list.lat != '' && list.lat != '0' && list.lat != 0){
              const objectLatLng: any = {
                lat: list.lat,
                lng: list.lng
              }
              this.loadObjectMarker(objectLatLng,list)
              latLngPoints.push({ lat: objectLatLng.lat, lng: objectLatLng.lng });
            }
          
          }
        }  
      },
      (err: any) => {
        console.log(err);
      }
    );




      setTimeout(() => {
        if (latLngPoints.length > 0) {
          const latLngs = latLngPoints.map(item => [item.lat, item.lng] as [number, number]);
          const bounds = L.latLngBounds(latLngs);
          const center = bounds.getCenter(); // find midpoint of all markers

          // ✅ Move map to center, keep current zoom
          this.map.setView(center, this.map.getZoom());

          // Ensure map redraws properly
          this.map.invalidateSize();
        }
      }, 2500);

  }

  customerCheck(){
    console.log(this.isCustomer)
    this.removeMarker();
    
    console.log('Checked locations:', this.locationCheckList);

    if (this.locationCheckList.length === 0) return;

    const latLngPoints: { lat: number; lng: number }[] = [];

    // ✅ Combine both API calls
    const customerRequests = this.locationCheckList.map((loc: any) =>
      this.generic_service.getTelcoCustomerByLocation(loc.zone)
    );
    const objectRequests = this.locationCheckList.map((loc: any) =>
      this.generic_service.getAllByLocationAndCid(loc.zone)
    );

    forkJoin([forkJoin(customerRequests), forkJoin(objectRequests)]).subscribe(
      ([customerResponses, objectResponses]: any[]) => {
        // --- Handle Customers ---
        for (const res of customerResponses) {
          if (res.response) {
            this.telcoCustomerList.push(...res.response);
          }
        }

        for (const customer of this.telcoCustomerList) {
          const latLng = customer.customerLatLng;
          if (this.isValidLatLng(latLng)) {
            this.loadMarker(latLng, customer);
            latLngPoints.push({ lat: latLng.lat, lng: latLng.lng });
          }
        }

        // --- Handle Objects ---
        for (const res of objectResponses) {
          if (res.response) {
            this.locationObjectInfoList.push(...res.response);
          }
        }

        if(!this.isCustomer){
          for (const obj of this.locationObjectInfoList) {
            if(obj.multiLatLng){
              if(obj.area && obj.area != null && obj.area.lenght != 0 ){
                this.loadObjectPolyline(obj.area,obj)
              }
            }else{
              if (this.isValidLatLng(obj)) {
                const latLng = { lat: obj.lat, lng: obj.lng };
                this.loadObjectMarker(latLng, obj);
                latLngPoints.push(latLng);
              }
            }
          }
        }



        // ✅ Now center map safely
        if (latLngPoints.length > 0) {
          // const latLngs = latLngPoints.map(p => [p.lat, p.lng] as [number, number]);
          // const bounds = L.latLngBounds(latLngs);
          // const center = bounds.getCenter();
          // this.map.setView(center, this.map.getZoom());
          // this.map.invalidateSize();

          const latLngs = latLngPoints.map(p => [p.lat, p.lng] as [number, number]);
          const bounds = L.latLngBounds(latLngs);

          // ✅ Zoom & center automatically to fit all points
          this.map.fitBounds(bounds, { padding: [50, 50] });

          // Optional: ensure proper rendering if container size changed
          this.map.invalidateSize();
        }
      },
      (err) => console.error(err)
    );
  }


  locationCheck(list: any, checked: boolean) {
    this.removeMarker();
    this.telcoCustomerList = [];
    this.locationObjectInfoList = [];

    // ✅ Toggle selection
    if (!checked) {
      list.isChecked = true;
      this.locationCheckList.push(list);
    } else {
      const index = this.locationCheckList.findIndex(
        (loc: any) => loc.locationId === list.locationId
      );
      if (index !== -1) this.locationCheckList.splice(index, 1);
      list.isChecked = false;
    }

    console.log('Checked locations:', this.locationCheckList);

    if (this.locationCheckList.length === 0) return;

    const latLngPoints: { lat: number; lng: number }[] = [];

    // ✅ Combine both API calls
    const customerRequests = this.locationCheckList.map((loc: any) =>
      this.generic_service.getTelcoCustomerByLocation(loc.zone)
    );
    const objectRequests = this.locationCheckList.map((loc: any) =>
      this.generic_service.getAllByLocationAndCid(loc.zone)
    );

    forkJoin([forkJoin(customerRequests), forkJoin(objectRequests)]).subscribe(
      ([customerResponses, objectResponses]: any[]) => {
        // --- Handle Customers ---
        for (const res of customerResponses) {
          if (res.response) {
            this.telcoCustomerList.push(...res.response);
          }
        }

        for (const customer of this.telcoCustomerList) {
          const latLng = customer.customerLatLng;
          if (this.isValidLatLng(latLng)) {
            this.loadMarker(latLng, customer);
            latLngPoints.push({ lat: latLng.lat, lng: latLng.lng });
          }
        }

        // --- Handle Objects ---
        for (const res of objectResponses) {
          if (res.response) {
            this.locationObjectInfoList.push(...res.response);
          }
        }

        if(!this.isCustomer){
          for (const obj of this.locationObjectInfoList) {
            if(obj.multiLatLng){
              if(obj.area && obj.area != null && obj.area.lenght != 0 ){
                this.loadObjectPolyline(obj.area,obj)
              }
            }else{
              if (this.isValidLatLng(obj)) {
                const latLng = { lat: obj.lat, lng: obj.lng };
                this.loadObjectMarker(latLng, obj);
                latLngPoints.push(latLng);
              }
            }
          }
        }



        // ✅ Now center map safely
        if (latLngPoints.length > 0) {
          // const latLngs = latLngPoints.map(p => [p.lat, p.lng] as [number, number]);
          // const bounds = L.latLngBounds(latLngs);
          // const center = bounds.getCenter();
          // this.map.setView(center, this.map.getZoom());
          // this.map.invalidateSize();

          const latLngs = latLngPoints.map(p => [p.lat, p.lng] as [number, number]);
          const bounds = L.latLngBounds(latLngs);

          // ✅ Zoom & center automatically to fit all points
          this.map.fitBounds(bounds, { padding: [50, 50] });

          // Optional: ensure proper rendering if container size changed
          this.map.invalidateSize();
        }
      },
      (err) => console.error(err)
    );
  }

// ✅ Helper function to validate coordinates
private isValidLatLng(latLng: any): boolean {
  return (
    latLng &&
    latLng.lat &&
    latLng.lng &&
    latLng.lat !== '0' &&
    latLng.lng !== '0' &&
    latLng.lat !== 0 &&
    latLng.lng !== 0 &&
    latLng.lat !== '' &&
    latLng.lng !== ''
  );
}





  private parentLineLayer?: any;

  async getParent(objectInfoId: number): Promise<void> {
    console.log("Fetching all parents for:", objectInfoId);

    const parentsObjects: any[] = [];
    const visitedIds: Set<number> = new Set();

    const fetchRecursive = async (id: number) => {
      if (visitedIds.has(id)) return;
      visitedIds.add(id);

      try {
        const response: any = await this.generic_service.getObjectInfoById(id).toPromise();
        const data = response?.response;

        if (!data || !data.lat || data.lat === 0) return;

        parentsObjects.push(data);

        if (Array.isArray(data.parentAssetId) && data.parentAssetId.length > 0) {
          for (const parentId of data.parentAssetId) {
            if (parentId && parentId !== 0) {
              await fetchRecursive(parentId);
            }
          }
        }

      } catch (error) {
        console.error(`Error fetching parent for ID ${id}:`, error);
      }
    };

    // Fetch all parent data
    await fetchRecursive(objectInfoId);
    console.log("All parents fetched:", parentsObjects);

    // Remove old lines if any
    if (this.parentLineLayer) {
      this.map.removeLayer(this.parentLineLayer);
    }

    // Draw connecting lines
    const features: any[] = [];
    for (const obj of parentsObjects) {
      if (Array.isArray(obj.parentAssetId)) {
        for (const pid of obj.parentAssetId) {
          const parentObj = parentsObjects.find(p => p.objectInfoId === pid);
          if (parentObj && obj.lat && obj.lng && parentObj.lat && parentObj.lng) {
            features.push({
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: [
                  [obj.lng, obj.lat],
                  [parentObj.lng, parentObj.lat]
                ]
              }
            });
          }
        }
      }
    }

    this.parentLineLayer = L.geoJSON({
      type: 'FeatureCollection',
      features
    }, {
      style: { color: 'red', weight: 9, opacity: 1 }
    });

    this.parentLineLayer.addTo(this.map);

    // Adjust map bounds
    const latlngs = parentsObjects.map(o => [o.lat, o.lng]) as [number, number][];
    if (latlngs.length > 0) {
      this.map.fitBounds(latlngs);
    }
  }


  imageUrl: any = ""
  imageUrlSelect(url:any){
    this.imageUrl = url
  }







loadObjectMarker(latLng: { lat: number, lng: number }, list: any): void {
  const iconUrl = list.icon || 'assets/image (1).png';
  const customHtmlIcon = L.divIcon({
    className: '',
    html: `
      <div style="
        position: relative;
        width: 40px;
        height: 40px;
        background: white;
        border: 3px solid #e94141ff;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      ">
        <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
        <div style="
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 15px solid #2c3e50;
        "></div>
      </div>
    `,
    iconAnchor: [30, 30],
    popupAnchor: [0, 0]
  });

  const marker = L.marker([latLng.lat, latLng.lng], { icon: customHtmlIcon }).addTo(this.map)
        .on('click', () => {
          this.singleObjectInfoData = []
          this.singleObjectInfoData.push(list)
          let obj = {
            "Id": this.singleObjectInfoData[0]?.objectInfoId || "",
            "Name": this.singleObjectInfoData[0]?.givenName || "",
            "Condition": this.singleObjectInfoData[0]?.objectCondition || "",
          }
          this.jsonString = JSON.stringify(obj);
          document.getElementById('view-object')?.click()

        });
}


loadObjectPolyline(latlngs: { lat: number, lng: number }[], list: any): void {


  // Default styling for the polyline
  const defaultOptions = {
    color: list.objectColorCode || 'black',
    weight: 6,
    opacity: 0.8,
  };

  // Create the polyline
  const polyline = L.polyline(latlngs, defaultOptions).addTo(this.map);

  // Zoom the map to fit the polyline bounds
  this.map.fitBounds(polyline.getBounds());

  // Optional: add a click event on the polyline
  polyline.on('click', () => {
          this.singleObjectInfoData = []
          this.singleObjectInfoData.push(list)
          let obj = {
            "Id": this.singleObjectInfoData[0]?.objectInfoId || "",
            "Name": this.singleObjectInfoData[0]?.givenName || "",
            "Condition": this.singleObjectInfoData[0]?.objectCondition || "",
          }
          this.jsonString = JSON.stringify(obj);
          document.getElementById('view-object')?.click()

        });
}


}
